import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'

@Injectable({
	providedIn: 'root',
})
export class TitleResolutionService extends TitleStrategy {
	constructor(private readonly title: Title) {
		super()
	}

	override updateTitle(routerState: RouterStateSnapshot) {
		const title = this.buildTitle(routerState)
		this.title.setTitle(`Trakr${!!title ? ` | ${title}` : ''}`)
	}
}
